/* E-Drug - warstwa zachowan artykulu bloga (2026-09-22)
   Spis tresci, podswietlanie aktywnej sekcji, pasek postepu.
   Nie dotyka zadnego skryptu motywu. */
(function () {
  'use strict';

  var body = document.querySelector('.ed-body');
  if (!body) return;

  /* ---- 1. Spis tresci z naglowkow w tresci ------------------------------ */
  var heads = body.querySelectorAll('h2, h3, h4');
  var used = Object.create(null);
  var items = [];

  function slug(text) {
    var s = text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60) || 'section';
    if (used[s]) { used[s]++; s = s + '-' + used[s]; } else { used[s] = 1; }
    return s;
  }

  for (var i = 0; i < heads.length; i++) {
    var h = heads[i];
    var text = (h.textContent || '').trim();
    if (!text) continue;
    if (!h.id) h.id = slug(text);
    items.push({ id: h.id, text: text, level: Number(h.tagName.charAt(1)), el: h });
  }

  var tocs = document.querySelectorAll('[data-ed-toc]');
  if (items.length >= 3 && tocs.length) {
    var listHTML = items.map(function (it) {
      return '<li class="lvl-' + it.level + '"><a href="#' + it.id + '">' +
        it.text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</a></li>';
    }).join('');
    for (var t = 0; t < tocs.length; t++) {
      tocs[t].innerHTML = '<ol>' + listHTML + '</ol>';
      tocs[t].closest('.ed-toc').hidden = false;
    }
  } else {
    var empties = document.querySelectorAll('.ed-toc');
    for (var e = 0; e < empties.length; e++) empties[e].remove();
  }

  /* ---- 2. Podswietlanie aktywnej pozycji -------------------------------- */
  var links = document.querySelectorAll('[data-ed-toc] a');
  if (links.length && 'IntersectionObserver' in window) {
    var byId = {};
    for (var L = 0; L < links.length; L++) {
      byId[links[L].getAttribute('href').slice(1)] = byId[links[L].getAttribute('href').slice(1)] || [];
      byId[links[L].getAttribute('href').slice(1)].push(links[L]);
    }
    var visible = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = en.target.id;
        var at = visible.indexOf(id);
        if (en.isIntersecting && at === -1) visible.push(id);
        if (!en.isIntersecting && at > -1) visible.splice(at, 1);
      });
      var current = visible.length
        ? items.filter(function (it) { return visible.indexOf(it.id) > -1; })[0]
        : null;
      for (var k = 0; k < links.length; k++) links[k].classList.remove('is-active');
      if (current && byId[current.id]) {
        byId[current.id].forEach(function (a) {
          a.classList.add('is-active');
          var nav = a.closest('nav');
          if (nav && nav.scrollHeight > nav.clientHeight) {
            var top = a.offsetTop - nav.clientHeight / 2 + a.clientHeight / 2;
            nav.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      }
    }, { rootMargin: '-100px 0px -65% 0px', threshold: 0 });
    items.forEach(function (it) { io.observe(it.el); });
  }

  /* ---- 3. Pasek postepu czytania ---------------------------------------- */
  var bar = document.querySelector('.ed-progress__bar');
  if (bar) {
    var ticking = false;
    var update = function () {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var done = total > 0 ? (-rect.top) / total : (rect.top < 0 ? 1 : 0);
      bar.style.width = Math.max(0, Math.min(1, done)) * 100 + '%';
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

})();
